import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=01884f77&scoped=true"
import script from "./OverviewView.vue?vue&type=script&lang=js"
export * from "./OverviewView.vue?vue&type=script&lang=js"
import style0 from "./OverviewView.vue?vue&type=style&index=0&id=01884f77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01884f77",
  null
  
)

export default component.exports